import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { SearchTitle } from '@/workbook/SearchTitle.organism';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface SearchTitleIF extends ValidatingFormComponent<string> {
  component: 'SearchTitleFormComponent';
  id?: string;
  onChange: (name: string) => void;
  searchIconClass?: string;
  defaultName?: string;
  color?: string;
  onColorChange?: (color: string) => void;
  extraClassNames?: any;
  types?: string[];
}

export const SearchTitleFormComponent = (props: SearchTitleIF) => {
  const { name, validation, value, testId, onChange, extendValidation, extraClassNames, types } = props;
  const defaultValidation = (value: string | undefined) => _.isEmpty(_.trim(value));
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <div className={clsx('flexFill searchTitleContainer tw:mb-sq-15', extraClassNames)} data-testid={testId}>
      <Field<string> name={name} validate={appliedValidation}>
        {({ input, meta }) => (
          <SearchTitle
            {...getFormFieldProps(formState, input, meta, props)}
            name={value}
            setSearchName={(value: string) => {
              input.onChange(value);
              onChange(value);
            }}
            types={types}
          />
        )}
      </Field>
    </div>
  );
};
